__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ourecycler";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ecomaison-locale", "20.0.0", () => (__webpack_require__.e(60).then(() => (() => (__webpack_require__(26679))))));
			register("@ecomaison-service-analytics", "20.0.0", () => (__webpack_require__.e(617).then(() => (() => (__webpack_require__(89617))))));
			register("@front-office/context", "20.0.0", () => (Promise.all([__webpack_require__.e(839), __webpack_require__.e(294), __webpack_require__.e(433)]).then(() => (() => (__webpack_require__(11814))))));
			register("react-dom", "19.2.7", () => (() => (__webpack_require__(28485))), 1);
			register("react-final-form", "0", () => (Promise.all([__webpack_require__.e(296), __webpack_require__.e(300)]).then(() => (() => (__webpack_require__(38300))))));
			register("react-intl", "10.1.11", () => (__webpack_require__.e(375).then(() => (() => (__webpack_require__(23375))))));
			register("react-jss", "10.4.0", () => (__webpack_require__.e(334).then(() => (() => (__webpack_require__(34334))))));
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(45237))), 1);
			register("react-router", "5.3.4", () => (() => (__webpack_require__(88351))), 1);
			register("react", "19.2.7", () => (() => (__webpack_require__(7552))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};